import './index.css';

import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { yupCustomEmailValidation } from 'ui/form-validations/emailValidation';

import App from './App';
import reportWebVitals from './reportWebVitals';

yupCustomEmailValidation();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
